const createMaskedPan = (pan: string) => {
  return `${pan.substring(0, 4)} ${pan.substring(4, 6)}** **** ${pan.substring(12)}`;
};

const createBankBin = (pan: string) => {
  const digits = pan.match(/\d/g)?.join('');

  return digits?.substring(0, 6) ?? '';
};

export { createBankBin, createMaskedPan };
